export default __webpack_public_path__ + "static/media/mo.ab5e90e7.svg";